import { Dispatch } from 'react';
import * as ActionTypes from 'src/constants/ActionTypes';
import { IStoreState, IStateSpuTCM } from 'src/entity/StateEntity';
import { MallService } from 'src/services/MallService';
import { ISpuMedicineDetail } from 'src/entity/SpuEntity';
import { EnumMedicineCategory } from 'src/constants/enum';

export function reloadSpuTCM(): IStateSpuTCM {
  return {
    reload: true,
    isFetching: false,
    type: ActionTypes.SPU_TCM_STATUS_RELOAD,
    tcmList: [],
  };
}

export function requestSpuTCM(): IStateSpuTCM {
  return {
    reload: false,
    isFetching: true,
    type: ActionTypes.SPU_TCM_STATUS_REQUEST,
    tcmList: [],
  };
}

function receiveSpuTCM(tcmList: ISpuMedicineDetail[], isSuccess: boolean): IStateSpuTCM {
  return {
    reload: !isSuccess,
    isFetching: false,
    type: isSuccess ? ActionTypes.SPU_TCM_STATUS_SUCCESS : ActionTypes.SPU_TCM_STATUS_FAILURE,
    tcmList,
  };
}

export function fetchSpuTCM(): any {
  return async (dispatch: Dispatch<IStateSpuTCM>) => {
    dispatch(reloadSpuTCM());
    return MallService.getSpuMedicineList({ categoryCode: EnumMedicineCategory.中药 })
      .then(res => dispatch(receiveSpuTCM(res.results, true)))
      .catch(error => dispatch(receiveSpuTCM([], false)));
  };
}

export function shouldFetchSpuTCM(spuTcmState: IStateSpuTCM): boolean {
  return (spuTcmState.reload || spuTcmState.tcmList.length === 0) && !spuTcmState.isFetching;
}

export function fetchSpuTCMIfNeeded(): any {
  return (dispatch: Dispatch<IStateSpuTCM>, getState: any) => {
    const { spuTcmState } = getState() as IStoreState;
    if (shouldFetchSpuTCM(spuTcmState)) {
      return dispatch(fetchSpuTCM());
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/spuTCMCreator.ts